import {OSkinableInit} from "back/commons/basis";
import {AppFrameDeskFeat, IApp, IAppBuilder, IAppCtx, JAppDef} from "back/core/appFrame";
import {DynGenApp} from "back/wsp/apps/dynGenApp";
import {SimpleTagArea} from "lib/commons/areas";
import {IReg, REG} from 'lib/commons/registry';
import {JSX} from "lib/commons/xml/dom";
import {IChainEnv} from "lib/wsp/chain";
import {srcRef} from "lib/wsp/src";
import {wspCd} from "lib/wsp/wsp";

/**
 * InteractiveGenerator comme une vue principale dans une appFrame.
 * A appeler au cours du processus d'init du desk (qui doit disposer de AppFrameDeskFeat).
 *
 * @param reg Registre à exploiter, nécessaire en cas de front multi-universe.
 */
export function initApp(reg: IReg<IChainEnv> = REG.reg) {
	const d = desk as AppFrameDeskFeat;
	d.addAppBuilder(new DynGenAppBuilder(reg));
}

/**
 * Schéma du hash de l'URL pour le DynGenApp.
 * exemple : (dynGen(w'001C42jx3eXsm0yhoUWVZb'c'edit'r'id:003C42jx3eXsm0yhoUWVZb'))
 */
export interface JDynGenAppDef extends JAppDef {
	dynGen: JDynGenDatas
}

export interface JDynGenDatas {
	/** wspCd */
	w: wspCd
	/** codeGen */
	c: string
	/** refUri de la racine de la dynGen. */
	r: srcRef
	/** genProps (skin, etc) */
	gp?: Jsonisable
	/** pathPage pour construire le dialogue ("co/" par défaut) */
	pp?: string
	/** queryString passé au dialogue  */
	qs?: string
}

/** Construction async de l'app DynGenApp. */
class DynGenAppBuilder extends SimpleTagArea<IAppCtx<IChainEnv>, IApp<IChainEnv>> implements OSkinableInit, IAppBuilder<IChainEnv, IChainEnv> {

	skin?: string;

	skinOver?: string;

	constructor(public reg: IReg<IChainEnv>) {
		super('wsp-dyngen-app', reg.env.resolver.resolve(":back:wsp/apps/dynGenApp.js"));
	}

	isAppDefMatch(data: JDynGenAppDef) {return typeof data.dynGen === 'object'}

	newElt(ctx: IAppCtx<IChainEnv> & OSkinableInit): DynGenApp {
		if (!ctx.skin) ctx.skin = this.skin;
		if (!ctx.skinOver) ctx.skinOver = this.skinOver;
		ctx.reg = this.reg;
		return (super.newElt(ctx) as DynGenApp).initialize(ctx);
	}
}
